module.exports = __webpack_public_path__ + "static/img/learn_more.2ae11831.png";